import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Space, Typography, ModalProps } from 'antd';
import styled from 'styled-components';
import { type Dispatch, type FC, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

const BravoWarningIcon = styled(ExclamationCircleOutlined)`
  color: var(--warning-color);
  font-size: 1.375rem;
`;

type UseStateAction = Dispatch<SetStateAction<boolean>>;
type ExtendedCancelButtonProps = ModalProps['cancelButtonProps'];

export interface ClaimDetailsModalProps {
  handleOk: () => void;
  visible: boolean;
  setVisibility: UseStateAction;
  modalLoading: boolean;
  title: string;
  description?: string;
  cancelButtonProps?: ExtendedCancelButtonProps;
}

const ClaimDetailsModal: FC<ClaimDetailsModalProps> = ({
  handleOk,
  visible,
  setVisibility,
  modalLoading,
  title,
  description,
  cancelButtonProps,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      okText={t('common.ok')}
      cancelText={t('common.cancel')}
      cancelButtonProps={cancelButtonProps}
      open={visible}
      onOk={handleOk}
      confirmLoading={modalLoading}
      onCancel={() => setVisibility(false)}
    >
      <Space align="start">
        <BravoWarningIcon />
        <div>
          <Title level={5}>{title}</Title>
          {description && <Text>{description}</Text>}
        </div>
      </Space>
    </Modal>
  );
};

export default ClaimDetailsModal;
